import { ICityResponse } from '../models/request-and-responses/rest-api/interfaces/cityResponse';

export interface ICity extends ICityResponse {
    fullName: string;
}
class CityResponse implements ICityResponse {
    codIstatCity: string;
    name: string;
    postalCode: string;
    province: string;
    idProvince: string;
    shortProvince: string;
    constructor(cityResponse: ICityResponse) {
        if (cityResponse != null) {
            this.codIstatCity = cityResponse.codIstatCity;
            this.name = cityResponse.name;
            this.postalCode = cityResponse.postalCode;
            this.province = cityResponse.province;
            this.idProvince = cityResponse.idProvince;
            this.shortProvince = cityResponse.shortProvince;
        }
    }
}

export class City extends CityResponse implements ICity {
    fullName: string;
    constructor(cityResponse: ICityResponse) {
        super(cityResponse);
        if (
            cityResponse != null &&
            cityResponse.name != null &&
            cityResponse.shortProvince != null
        ) {
            this.fullName = `${cityResponse.name} (${cityResponse.shortProvince})`;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/helpers/city.class.ts